import { render, staticRenderFns } from "./intgsetupNew.vue?vue&type=template&id=c9515b90"
import script from "./intgsetupNew.vue?vue&type=script&lang=js"
export * from "./intgsetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports